import React, { useEffect } from 'react';
import { DocumentProps, PageProps, pdfjs, Document, Page } from 'react-pdf';
import makeStyles from '@mui/styles/makeStyles';
import usePage from '@monorepo/shared/src/hooks/use-page';
import { LetterBookZoom } from '../../../types';
import { loadPdfWorker } from './util/pdf-util';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

type Props = {
  documentProps: DocumentProps;
  pageProps?: PageProps;
};

const BasePdfDocument: React.FC<Props> = ({ documentProps, pageProps }) => {
  const [{ zoomed }] = usePage();
  const classes = useStyles();

  useEffect(() => loadPdfWorker(pdfjs.version), []);

  return (
    <Document {...documentProps} className={classes.document} renderMode="canvas">
      <Page
        {...pageProps}
        className={!zoomed ? classes.page : ''}
        scale={zoomed ? LetterBookZoom.ZOOMED : LetterBookZoom.DEFAULT * 2}
        renderTextLayer={false}
        renderAnnotationLayer={false}
      />
    </Document>
  );
};

const useStyles = makeStyles(() => ({
  document: {
    height: '100%',
  },
  page: {
    height: '100%',
    width: 'auto !important',
    maxHeight: '100%',
    '& canvas:first-of-type': {
      height: '100% !important',
      width: 'auto !important',
      maxWidth: '100%',
      maxHeight: '100%',
    },
  },
}));

export default BasePdfDocument;
